(() => {
  window.addEventListener('load', function () {
    const biocard = document.querySelector('#bioCardSlide');
    const flkty = new Flickity(biocard, {
      cellAlign: 'left',
      groupCells: true,
      arrowShape: {
        x0: 10,
        x1: 60,
        y1: 50,
        x2: 70,
        y2: 40,
        x3: 30,
      },
      contain: true,
      pageDots: false,
    });
  });
})();
// M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z
